import type { DialogBaseProps } from "@freightsimple/ui-core/Dialog/DialogBaseProps";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { ControlPresentationProvider } from "@freightsimple/ui-core/Controls/ControlPresentationProvider";
import { Dialog } from "@freightsimple/ui-core/Dialog/Dialog";
import { Image } from "@freightsimple/ui-core/Display/Image";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";

interface BankAccountsAdviceDialogProps extends DialogBaseProps {
  /** Fired when the user acknowledges the advice — the Stripe flow starts. */
  onGotIt: () => void;
}

// Shown before the Stripe bank-connection popup: steers the customer toward
// "Manually Verify" (void cheque details). Replaces the legacy imperative
// modal.
export function BankAccountsAdviceDialog(props: BankAccountsAdviceDialogProps) {
  return (
    <Dialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      title="Connect Bank Account with Void Cheque Information"
      width="medium"
      footer={
        <Button primary onClick={props.onGotIt}>
          Got it!
        </Button>
      }
    >
      <ControlPresentationProvider presentation="underlined">
        {/* Prose reads left-aligned, like the dialog's own title — the whole
            body used to be centred, which set the paragraphs ragged on both
            edges under a left-aligned heading. Only the screenshot is centred,
            because it's a figure rather than a line of text. */}
        <Stack gap={4}>
          <T size="sm" color="secondary">
            Connecting your bank account enables easy convenient payments for
            your freight. You have the option to connect with your online bank's
            username and password, if you have it.
          </T>
          <T size="sm" color="secondary">
            More likely, you want to enter your account's void cheque
            information. This is called 'Manually Verify'.
          </T>
          <Row justify="center" grow>
            <Image
              src="/manualBankVerify.png"
              alt="Screenshot showing the Manually Verify option"
              maxWidth={500}
            />
          </Row>
          <T size="sm" color="secondary">
            Make sure you click on 'Manually Verify' at the bottom of the next
            screen to enter void cheque info.
          </T>
        </Stack>
      </ControlPresentationProvider>
    </Dialog>
  );
}
